export const PAGE_LIMIT = 10;
export const LOGIN = {
  CURRENT_MODULE: "Login",
  TOP_CONTENT: "WELCOME BACK !",
  MAIN_CONTENT: "Sign in to continue zenaura",
  BUTTON: "SIGN IN",
};
export const FORGOT_PASSWORD = {
  CURRENT_MODULE: "Forgot Password",
  TOP_CONTENT: "WELCOME BACK !",
  MAIN_CONTENT: "We will send a link to reset your password",
  BUTTON: "Forgot Password",
};
export const RESET_PASSWORD = {
  CURRENT_MODULE: "Reset Password",
  TOP_CONTENT: "WELCOME BACK !",
  MAIN_CONTENT: "Here you can reset your password",
  BUTTON: "Reset Password",
};
export const DASHBOARD = {
  CURRENT_MODULE: "Dashboard",
};
export const PROFILE = {
  CURRENT_MODULE: "Profile",
};
export const APPLICATION = {
  CURRENT_MODULE: "Application",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Detail",
};
export const CHANGE_PASSWORD = {
  CURRENT_MODULE: "Change Password",
};
export const CONTACT_SUPPORT = {
  CURRENT_MODULE: "Contact Support",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Detail",
};
export const TRANSACTION = {
  CURRENT_MODULE: "Transactions",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Transaction Detail",
};
export const USERS = {
  CURRENT_MODULE: "Users",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "User Detail",
};

export const USERS_PREFERENCES = {
  CURRENT_MODULE: "Match Prefrences",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Match Detail",
};
export const MATCH_TENNIS = {
  CURRENT_MODULE: "Tennis Match",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Tennis Match Detail",
};
export const CATEGORY = {
  CURRENT_MODULE: "Categories",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Category Detail",
};
export const SUBCATEGORY = {
  CURRENT_MODULE: "SubCategories",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "SubCategory Detail",
};
export const POST = {
  CURRENT_MODULE: "Post",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Post Detail",
};
export const COACH = {
  CURRENT_MODULE: "Coach",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Coach Detail",
};
export const FEED_REPORT = {
  CURRENT_MODULE: "Feed Reports",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Feed Report Detail",
};
export const SYSTMENACCESS = {
  CURRENT_MODULE: "System Access",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "System Access Detail",
};
export const PROMOCODE = {
  CURRENT_MODULE: "Promocode",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Promocode Detail",
};
export const USER_PROMOCODE = {
  CURRENT_MODULE: "User Promo's",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "User Promo's Detail",
};
export const CMS = {
  CURRENT_MODULE: "Content Pages",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Detail",
};
export const FAQ = {
  CURRENT_MODULE: "FAQ",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Detail",
};
export const EARNING = {
  CURRENT_MODULE: "Earning Management",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Earning Management Detail",
};
export const REPORTS = {
  CURRENT_MODULE: "Reports",
  CURRENT_LIST: "",
  CURRENT_VIEW: "",
};
export const PAYOUT = {
  CURRENT_MODULE: "Mangae Payout",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Mangae Payout Detail",
};
export const CONFIGURATION = {
  CURRENT_MODULE: "Configuration",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Detail",
};
export const BASIC_SETTING = {
  CURRENT_MODULE: "Basic Setting",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Detail",
};
export const SUPPORT = {
  CURRENT_MODULE: "Support",
  CURRENT_LIST: "Listing",
  CURRENT_VIEW: "Support Detail",
};
